import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import AddSingleItem from './AddSingleItem';
import AddBulkItems from './AddBulkItems';
import UpdateBulkBucketPrices from './UpdateBulkBucketPrices';
import RenameBucketDialogBox from '../Commons/RenameBucketDialogBox';
import DeleteBucketDialogBox from '../Commons/DeleteBucketDialogBox';
import CloneBucketDialogBox from './CloneBucketDialogBox';
import DeleteItemDialogBox from './DeleteItemDialogBox';
import DownloadInventoryItems from './DownloadInventoryItems';
import DownloadSupplierProductIds from './DownloadSupplierProductIds';
import DownloadPrices from './DownloadPrices';

import NotFoundIcon from './../../assets/icons/not-found.png';
import { ProcessingIcon, AddIcon, ItemStatusIcon, StockStatusIcon, ArrowDownIcon, EditIcon, CloneIcon, TrashIcon, 
	PlusIcon, ChangeIcon, DownloadIcon, StockStatusDropdownIcon, RefreshInventoryIcon, IndexStatusIcon } from './Styles/Icons';
import { RootContainer, FlexRow, FlexColumn, Popover, PopoverBody, PopoverTitle, PopoverItem, Button, FilterButton, 
	DatePicker, NotFound, ButtonGroup, PriceColumn, Price, CircularButton, Search, ProductImage, TitleSection, Title, 
	LocalizationProvider, TitleRow, SubtitleSection, SubtitleRow, Subtitle, TableContainer, Table, TableHeader, 
	TableHeaderRow, TableHeaderColumn, TableBody, TableRow, TableColumn, TablePagination, SquareButton, CloneHeaderColumn, 
	PriceHeaderColumn, PriceGroup, StockStatusColumn, Note } from './Styles/InventoryV2';

import { changeTile } from '../../actions/changeTile';
import { updateErrorMessage, updateSuccessMessage, updateMessage, updateError } from '../../actions/commonActions';
import { fetchInventoryItems, fetchBucketList, updateStatus, updateBucketPrice, cloneBucket, updateBucketOrder, 
	deleteInventory, updateInventory, setUploadInventoryFileAction, setUploadInventoryFileBatch, fetchUploadInventoryFileBatch, 
	fetchAutocompleteCategory, fetchAutocompletePackaging, fetchAutocompleteMappedDSO, fetchAutocompleteManufacturer, 
	fetchAutocompleteMappedSupplier } from '../../actions/inventoryActionsV2';
import { stripCurrency, formatCurrency, managePricingLogic, getDateTime24HoursBack } from '../../commons/utils';

import { SPJ_ACTIONS, STOCK_STATUS, BULK_FILE_UPLOAD_STAGES } from '../../commons/utils';
import { Theme } from '../Styles';

const PopoverIds = {
	FILTER_BY_ITEM_STATUS: 'filter-by-item-status-popover',
	FILTER_BY_STOCK_STATUS: 'filter-by-stock-status-popover',
	FILTER_BY_INDEX_STATUS: 'filter-by-index-status-popover',
	STOCK_STATUS: 'stock-status-popover',
	BUCKET: 'bucket-popover',
	ADD_BUCKET: 'add-bucket-popover',
	BULK_ACTIONS: 'bulk-actions-popover',
	OPTIONS: 'options-popover',
	DOWNLOAD_DATA: 'download-data',
};
const DialogIds = {
	RENAME_BUCKET: 'rename-bucket-dialog',
	CLONE_BUCKET: 'clone-bucket-dialog',
	DELETE_BUCKET: 'delete-bucket-dialog',
	DELETE_ITEM: 'delete-item-dialog',
	DOWNLOAD_INVENTORY_ITEMS: 'download-inventory-items',
	DOWNLOAD_SUPPLIER_PRODUCT_IDS: 'download-supplier-product_ids',
	DOWNLOAD_PRICES: 'download_prices',
};
const ItemStatusOptions = [
	{ name: 'All', value: '', disabled: false },
	{ name: 'Waiting', value: 'WAITING', disabled: false },
	{ name: 'Scheduled', value: 'SCHEDULED', disabled: true },
	{ name: 'Active', value: 'ACTIVE', disabled: false },
];
const StockStatusOptions = [
	{ name: 'All', value: '', disabled: false },
	{ name: 'In Stock', value: 'IN_STOCK', disabled: false },
	{ name: 'Out Of Stock', value: 'OUT_OF_STOCK', disabled: false },
	{ name: 'Back Order', value: 'BACKORDER', disabled: false },
];
const DATE_24_HOURS_BACK = getDateTime24HoursBack();

class InventoryV2 extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: '',
			pageSize: 10,
			pageNumber: 0,
			searchText: '',
			addSingleItemOpen: false,
			addBulkItemsOpen: false,
			bulkActionsPopoverAnchorEl: null,
			updateBulkItemsAndStatusOpen: false,
			updateBulkBucketPricesOpen: false,
			filterItemStatusPopoverItem: '',
			filterItemStatusPopoverAnchorEl: null,
			filterStockStatusPopoverItem: '',
			filterStockStatusPopoverAnchorEl: null,
			filterIndexStatusPopoverItem: '',
			filterIndexStatusPopoverAnchorEl: null,
			stockStatusPopoverItem: '',
			stockStatusPopoverAnchorEl: null,
			optionsPopoverItem: '',
			optionsPopoverAnchorEl: null,
			downloadDataPopoverItem: '',
			downloadDataPopoverAnchorEl: null,
			bucketPopoverItem: '',
			bucketPopoverAnchorEl: null,
			addBucketPopoverAnchorEl: null,
			bucketSearchText: '',
			priceSetRef: React.createRef(),
			priceColumnRef: React.createRef(),
			noOfPriceColumns: 0,
			renameBucketDialogOpen: false,
			deleteBucketDialogOpen: false,
			cloneBucketDialogOpen: false,
			cloneBucketDialogItem: '',
			deleteItemDialogItem: '',
			deleteItemDialogOpen: false,
			downloadInventoryItemsDialogOpen: false,
			downloadSupplierProductIdsDialogOpen: false,
			downloadPricesDialogOpen: false,
			updateItemProductId: '',
			inventoryCount: 0,
			inventoryItems: [],
			bucketItems: [],
			bucketOrder: [],
			bucketState: {},
			filteredBuckets: [],
			fetchingUploadInventoryFileBatch: false,
			datePickerOpen: false,
		};
	}

	calculateNoOfPriceColumns = () => {
		const priceSetRef = this.state?.priceSetRef;
		const priceColumnRef = this.state?.priceColumnRef;
		
		if (priceSetRef?.current && priceColumnRef?.current) {
			const priceSetWidth = priceSetRef.current.offsetWidth;
			const priceColumnWidth = priceColumnRef.current.offsetWidth;
			
			if (priceSetWidth > 0 && priceColumnWidth > 0) {
				let noOfPriceColumns = Math.floor(priceSetWidth / (priceColumnWidth + 48));
				return noOfPriceColumns - 1 > 1 ? noOfPriceColumns - 1 : 1;
			}
		}
		
		return this.state?.noOfPriceColumns || 1;
	}
	
	async componentDidMount() {
		if (this.props.tile !== 'INVENTORY') {
			this.props.changeTile('INVENTORY');
		}
		if (this.props.history.action === 'POP') {
			this.props.changeTile('INVENTORY');
		}

		let search = new URLSearchParams(this.props.location.search);
		const pageSize = parseInt(search.get('page_size'), 10);
		const pageNumber = parseInt(search.get('page_number'), 10);
		const searchText = search.get('search_text');
		const itemStatus = search.get('item_status');
		const stockStatus = search.get('stock_status');
		const indexStatus = search.get('index_status');

		this.setState(
			{
				searchText: searchText || '',
				pageNumber: pageNumber - 1 || 0,
				pageSize: pageSize || 10,
				filterItemStatusPopoverItem: itemStatus || '',
				filterStockStatusPopoverItem: stockStatus || '',
				filterIndexStatusPopoverItem: indexStatus || '',
			},
			async () => {
				await this.fetchInventoryItems();
				await this.props.fetchBucketList();
			}
		);

		this.fetchUploadInventoryFileBatch();
		this.fetchAutocompleteLists(true);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.supplier !== this.props.supplier) {
			this.setState({ searchText: '', pageNumber: 0, pageSize: 10, filterItemStatusPopoverItem: '', filterStockStatusPopoverItem: '', filterIndexStatusPopoverItem: '' }, async () => {
				this.refreshInventoryData();
			});
		}

		if (
			prevState.searchText !== this.state.searchText ||
			prevState.pageNumber !== this.state.pageNumber ||
			prevState.pageSize !== this.state.pageSize ||
			prevState.filterItemStatusPopoverItem !== this.state.filterItemStatusPopoverItem ||
			prevState.filterStockStatusPopoverItem !== this.state.filterStockStatusPopoverItem ||
			prevState.filterIndexStatusPopoverItem !== this.state.filterIndexStatusPopoverItem
		) {
			this.updateURL();
			this.fetchInventoryItems();
		}

		if (JSON.stringify(this.state.inventoryItems) !== JSON.stringify(this.props.inventory.items) || this.state.inventoryCount !== this.props.inventory.count) {
			this.setState({
				inventoryItems: this.props.inventory.items,
				inventoryCount: this.props.inventory.count,
			});
		}

		if (JSON.stringify(this.state.bucketItems) !== JSON.stringify(this.props.bucketItems)) {
			this.setState({ bucketItems: JSON.parse(JSON.stringify(this.props.bucketItems)) }, () => {
				this.handleBuckets();
			});
		}
	}

	refreshInventoryData = async () => {
		await this.fetchInventoryItems();
		await this.props.fetchBucketList();
		await this.fetchUploadInventoryFileBatch();
		this.updateURL();
		this.handleBuckets();
	};

	fetchAutocompleteLists = async (fetchOnComponentMount = false) => {
		let listAutocompleteRequests = [
			new Promise(async (resolve, reject) => {
				await this.props.fetchAutocompleteManufacturer();
			}),
		];

		if (fetchOnComponentMount) {
			listAutocompleteRequests = [
				...listAutocompleteRequests,
				new Promise(async (resolve, reject) => {
					await this.props.fetchAutocompleteMappedSupplier();
				}),
				new Promise(async (resolve, reject) => {
					await this.props.fetchAutocompleteMappedDSO();
				}),
				new Promise(async (resolve, reject) => {
					await this.props.fetchAutocompletePackaging();
				}),
				new Promise(async (resolve, reject) => {
					await this.props.fetchAutocompleteCategory();
				}),
			];
		}
		await Promise.all(listAutocompleteRequests);
	};

	fetchUploadInventoryFileBatch = async () => {
		this.props.setUploadInventoryFileAction(false);
		this.props.setUploadInventoryFileBatch('');

		this.setState({ fetchingUploadInventoryFileBatch: true });
		await this.props.fetchUploadInventoryFileBatch();
		this.setState({ fetchingUploadInventoryFileBatch: false });
	};

	updateURL = () => {
		let urlParams = {};
		let { pageSize, pageNumber, searchText, filterItemStatusPopoverItem, filterStockStatusPopoverItem, filterIndexStatusPopoverItem } = this.state;

		if (pageSize) urlParams['page_size'] = pageSize;
		if (pageNumber) urlParams['page_number'] = pageNumber + 1;
		if (searchText) urlParams['search_text'] = searchText;
		if (filterItemStatusPopoverItem) urlParams['item_status'] = filterItemStatusPopoverItem;
		if (filterStockStatusPopoverItem) urlParams['stock_status'] = filterStockStatusPopoverItem;
		if (filterIndexStatusPopoverItem) urlParams['index_status'] = filterIndexStatusPopoverItem;

		this.props.history.push({
			pathname: '/inventoryV2',
			search: '?' + new URLSearchParams(urlParams),
		});
	};

	handlePopoverClick = (popoverId, event) => {
		switch (popoverId) {
			case PopoverIds.BULK_ACTIONS:
				this.setState({ bulkActionsPopoverAnchorEl: event.currentTarget });
				break;

			case PopoverIds.ADD_BUCKET:
				this.setState({ addBucketPopoverAnchorEl: event.currentTarget });
				break;

			case PopoverIds.BUCKET:
				this.setState({ bucketPopoverAnchorEl: event.currentTarget });
				break;

			case PopoverIds.OPTIONS:
				this.setState({ optionsPopoverAnchorEl: event.currentTarget });
				break;

			case PopoverIds.STOCK_STATUS:
				this.setState({ stockStatusPopoverAnchorEl: event.currentTarget });
				break;

			case PopoverIds.FILTER_BY_ITEM_STATUS:
				this.setState({ filterItemStatusPopoverAnchorEl: event.currentTarget });
				break;

			case PopoverIds.FILTER_BY_STOCK_STATUS:
				this.setState({ filterStockStatusPopoverAnchorEl: event.currentTarget });
				break;

			case PopoverIds.FILTER_BY_INDEX_STATUS:
				this.setState({ filterIndexStatusPopoverAnchorEl: event.currentTarget });
				break;

			case PopoverIds.DOWNLOAD_DATA:
				this.setState({ downloadDataPopoverAnchorEl: event.currentTarget });
				break;

			default:
				break;
		}
	};

	handlePopoverSelect = (popoverId, choice) => {
		switch (popoverId) {
			case PopoverIds.BULK_ACTIONS:
				if (choice === 'ADD_BULK_ITEMS') {
					this.props.setUploadInventoryFileAction(true, SPJ_ACTIONS.INVENTORY_CREATE, BULK_FILE_UPLOAD_STAGES.UPLOAD);
					this.toggleAddBulkItems();
				} else if (choice === 'UPDATE_BULK_ITEMS_AND_STATUS') {
					this.props.setUploadInventoryFileAction(true, SPJ_ACTIONS.INVENTORY_UPDATE, BULK_FILE_UPLOAD_STAGES.UPLOAD);
					this.toggleUpdateBulkItemsAndStatusOpen();
				} else if (choice === 'UPDATE_BULK_BUCKET_PRICES') {
					this.props.setUploadInventoryFileAction(true, SPJ_ACTIONS.PRICE_UPDATE, BULK_FILE_UPLOAD_STAGES.UPLOAD);
					this.toggleUpdateBulkBucketPrices();
				} else if (choice === 'DELETE_BULK_ITEMS') {
				}
				break;

			case PopoverIds.ADD_BUCKET:
				this.handleCloneBucket(choice);
				break;

			case PopoverIds.BUCKET:
				let { bucketOrder, bucketState, bucketPopoverItem } = this.state;
				let index = bucketOrder.indexOf(bucketPopoverItem);

				bucketOrder[index] = choice;
				bucketState[bucketPopoverItem].display = false;
				bucketState[choice].display = true;

				this.setState({ bucketState, bucketOrder });
				this.props.updateBucketOrder(bucketOrder);
				this.handlePopoverClose(PopoverIds.OPTIONS);
				break;

			case PopoverIds.OPTIONS:
				if (choice === 'RENAME') {
					this.setState({ renameBucketDialogOpen: true });
				} else if (choice === 'CLONE') {
					this.handleCloneBucket(this.state.optionsPopoverItem);
				} else if (choice === 'DELETE') {
					this.setState({ deleteBucketDialogOpen: true });
				}
				break;

			case PopoverIds.STOCK_STATUS:
				this.props.updateStatus(this.state.stockStatusPopoverItem, choice);
				break;

			case PopoverIds.FILTER_BY_ITEM_STATUS:
				this.setState({ filterItemStatusPopoverItem: choice.value, pageNumber: 0 });
				break;

			case PopoverIds.FILTER_BY_STOCK_STATUS:
				this.setState({ filterStockStatusPopoverItem: choice.value, pageNumber: 0 });
				break;

			case PopoverIds.FILTER_BY_INDEX_STATUS:
				this.setState({ filterIndexStatusPopoverItem: choice.value, pageNumber: 0 });
				break;

			case PopoverIds.DOWNLOAD_DATA:
				if (choice === 'DOWNLOAD_INVENTORY_ITEMS') {
					this.setState({ downloadInventoryItemsDialogOpen: true });
				} else if (choice === 'DOWNLOAD_SUPPLIER_PRODUCT_IDS') {
					this.setState({ downloadSupplierProductIdsDialogOpen: true });
				} else if (choice === 'DOWNLOAD_PRICES') {
					this.setState({ downloadPricesDialogOpen: true });
				}
				break;

			default:
				break;
		}
		this.handlePopoverClose(popoverId);
	};

	handlePopoverClose = (popoverId) => {
		switch (popoverId) {
			case PopoverIds.BULK_ACTIONS:
				this.setState({ bulkActionsPopoverAnchorEl: null });
				break;

			case PopoverIds.ADD_BUCKET:
				this.setState({ addBucketPopoverAnchorEl: null, bucketSearchText: '', filteredBuckets: [] });
				break;

			case PopoverIds.BUCKET:
				this.setState({ bucketPopoverAnchorEl: null, bucketSearchText: '', filteredBuckets: [] });
				break;

			case PopoverIds.OPTIONS:
				this.setState({ optionsPopoverAnchorEl: null });
				break;

			case PopoverIds.STOCK_STATUS:
				this.setState({ stockStatusPopoverAnchorEl: null });
				break;

			case PopoverIds.FILTER_BY_ITEM_STATUS:
				this.setState({ filterItemStatusPopoverAnchorEl: null });
				break;

			case PopoverIds.FILTER_BY_STOCK_STATUS:
				this.setState({ filterStockStatusPopoverAnchorEl: null });
				break;

			case PopoverIds.FILTER_BY_INDEX_STATUS:
				this.setState({ filterIndexStatusPopoverAnchorEl: null });
				break;

			case PopoverIds.DOWNLOAD_DATA:
				this.setState({ downloadDataPopoverAnchorEl: null });
				break;

			default:
				break;
		}
	};

	handleDialogOnTrue = async (dialogId, value) => {
		switch (dialogId) {
			case DialogIds.RENAME_BUCKET:
				this.setState({ renameBucketDialogOpen: false });
				break;

			case DialogIds.CLONE_BUCKET:
				this.handleCloneBucketSubmit(value);
				this.setState({ cloneBucketDialogOpen: false });
				break;

			case DialogIds.DELETE_BUCKET:
				this.setState({ deleteBucketDialogOpen: false });
				break;

			case DialogIds.DELETE_ITEM:
				this.setState({ deleteItemDialogOpen: false });
				break;

			case DialogIds.DOWNLOAD_INVENTORY_ITEMS:
				this.setState({ downloadInventoryItemsDialogOpen: false });
				break;

			case DialogIds.DOWNLOAD_SUPPLIER_PRODUCT_IDS:
				this.setState({ downloadSupplierProductIdsDialogOpen: false });
				break;

			case DialogIds.DOWNLOAD_PRICES:
				this.setState({ downloadPricesDialogOpen: false });
				break;

			default:
				break;
		}
	};

	handleDialogOnFalse = (dialogId) => {
		switch (dialogId) {
			case DialogIds.RENAME_BUCKET:
				this.setState({ renameBucketDialogOpen: false });
				break;

			case DialogIds.CLONE_BUCKET:
				this.setState({ cloneBucketDialogOpen: false });
				break;

			case DialogIds.DELETE_BUCKET:
				this.setState({ deleteBucketDialogOpen: false });
				break;

			case DialogIds.DELETE_ITEM:
				this.setState({ deleteItemDialogOpen: false });
				break;

			case DialogIds.DOWNLOAD_INVENTORY_ITEMS:
				this.setState({ downloadInventoryItemsDialogOpen: false });
				break;

			case DialogIds.DOWNLOAD_SUPPLIER_PRODUCT_IDS:
				this.setState({ downloadSupplierProductIdsDialogOpen: false });
				break;

			case DialogIds.DOWNLOAD_PRICES:
				this.setState({ downloadPricesDialogOpen: false });
				break;

			default:
				break;
		}
	};

	handleBucketSearchText = (text = '') => {
		let newList = [];
		this.state.bucketItems.forEach((item, index) => {
			if (item.alias.toUpperCase().includes(text.toUpperCase())) newList.push(item.id);
		});
		this.setState({ bucketSearchText: text, filteredBuckets: newList });
	};

	handleSearchText = (text = '') => {
		this.setState({ searchText: text, pageNumber: 0 });
	};

	fetchInventoryItems = async () => {
		let { pageNumber, pageSize, searchText, filterItemStatusPopoverItem, filterStockStatusPopoverItem, filterIndexStatusPopoverItem } = this.state;
		
		let body = {
			page: pageNumber + 1, 
			size: pageSize, 
			search: searchText || "", 
			itemStatus: filterItemStatusPopoverItem, 
			stockStatus: filterStockStatusPopoverItem, 
			indexStatus: filterIndexStatusPopoverItem
		};
		
		await this.props.fetchInventoryItems(body);
	};

	handleBuckets = async () => {
		let noOfPriceColumns = this.calculateNoOfPriceColumns();
		this.setState({ noOfPriceColumns });

		let bucketItems = [...this.state.bucketItems];
		let bucketOrder = [...this.props.bucketOrder];
		let bucketState = {};

		console.log('Handling Buckets Started');
		console.log('Items', bucketItems);
		console.log('State', bucketState);
		console.log('Order', JSON.stringify(bucketOrder));

		for (let i = 0; i < bucketItems.length; i++) {
			bucketState[bucketItems[i].id] = { ...bucketItems[i], display: false };
		}

		let newBucketOrder = [];
		bucketOrder.forEach((bucket, index) => {
			if (Object.keys(bucketState).includes(bucket)) {
				newBucketOrder.push(bucket);
			}
		});
		bucketOrder = newBucketOrder;

		bucketOrder.forEach((bucket, index) => {
			bucketState[bucket].display = index < noOfPriceColumns;
		});

		let noOfPriceColumnsSoFar = bucketOrder.length;
		let index = 0;
		bucketItems = Object.keys(bucketState);

		while (noOfPriceColumnsSoFar < Math.min(bucketItems.length, noOfPriceColumns) && index < bucketItems.length) {
			if (!bucketState[bucketItems[index]].display) {
				bucketState[bucketItems[index]].display = true;
				bucketOrder.push(bucketItems[index]);
				noOfPriceColumnsSoFar += 1;
			}
			index += 1;
		}

		this.setState({ bucketState, bucketOrder }, async () => {
			console.log('Handling Buckets Done');
			console.log('Items', this.state.bucketItems);
			console.log('State', this.state.bucketState);
			console.log('Order', JSON.stringify(this.state.bucketOrder));
			await this.props.updateBucketOrder(bucketOrder);
		});
	};

	handleCloneBucket = async (source) => {
		this.setState({ cloneBucketDialogOpen: true, cloneBucketDialogItem: source });
	};

	handleCloneBucketSubmit = async (bucketDetails) => {
		bucketDetails['source'] = this.state.cloneBucketDialogItem;
		await this.props.cloneBucket(bucketDetails);

		let bucketOrder = [...this.props.bucketOrder];
		let bucketItems = [...this.props.bucketItems];
		let bucketState = { ...this.state.bucketState };

		console.log('Cloning Bucket Started');
		console.log('Items', bucketItems);
		console.log('State', bucketState);
		console.log('Order', JSON.stringify(bucketOrder));

		if (bucketOrder.length === this.state.noOfPriceColumns) {
			let lastBucketId = bucketOrder[bucketOrder.length - 1];
			bucketState[lastBucketId].display = false;
			bucketOrder.pop();
			let clonedBucketId = bucketItems[bucketItems.length - 1].id;
			bucketOrder.push(clonedBucketId);
		}

		this.setState({ bucketState, bucketOrder }, async () => {
			await this.props.updateBucketOrder(bucketOrder);
			console.log('Cloning Bucket Done');
			console.log('Items', bucketItems);
			console.log('State', bucketState);
			console.log('Order', JSON.stringify(bucketOrder));
			await this.fetchInventoryItems();
		});
	};

	handleUpdatePrice = async (productId, bucket, value) => {
		if (value === '' || value === undefined) value = null;
		else value = stripCurrency(value);

		this.state.inventoryItems.forEach(async (item, index) => {
			if (item.supplier_product_id === productId) {
				if (Object.keys(item).includes(`${bucket}_new`)) {
					if (item[`${bucket}_new`] !== value) {
						await this.props.updateBucketPrice(productId, bucket, value);
					}
				} else if (Object.keys(item).includes(bucket)) {
					if (item[`${bucket}`] !== value) {
						await this.props.updateBucketPrice(productId, bucket, value);
					}
				} else if (!Object.keys(item).includes(bucket)) {
					await this.props.updateBucketPrice(productId, bucket, value);
				}
			}
		});
	};

	toggleAddSingleItem = () => {
		if (this.state.addSingleItemOpen) this.setState({ addSingleItemOpen: false, updateItemProductId: '' });
		else this.setState({ addSingleItemOpen: true });
	};

	toggleAddBulkItems = () => {
		if (this.state.addBulkItemsOpen) this.setState({ addBulkItemsOpen: false });
		else this.setState({ addBulkItemsOpen: true });
	};

	toggleUpdateBulkItemsAndStatusOpen = () => {
		if (this.state.updateBulkItemsAndStatusOpen) this.setState({ addBulkItemsOpen: false, updateBulkItemsAndStatusOpen: false });
		else this.setState({ addBulkItemsOpen: true, updateBulkItemsAndStatusOpen: true });
	};

	toggleUpdateBulkBucketPrices = () => {
		this.setState({ updateBulkBucketPricesOpen: !this.state.updateBulkBucketPricesOpen });
	};

	showUploadInventoryFileDialog = () => {
		let { uploadInventoryFileType } = this.props;
		if (uploadInventoryFileType === SPJ_ACTIONS.INVENTORY_CREATE) {
			this.toggleAddBulkItems();
		} else if (uploadInventoryFileType === SPJ_ACTIONS.INVENTORY_UPDATE) {
			this.toggleUpdateBulkItemsAndStatusOpen();
		} else if (uploadInventoryFileType === SPJ_ACTIONS.PRICE_UPDATE) {
			this.toggleUpdateBulkBucketPrices();
		}
	};

	handleDateSelectOpen = () => {
		this.setState({ datePickerOpen: true });
	};

	handleDateSelectClose = () => {
		this.setState({ datePickerOpen: false });
	};

	handleUpdateScheduledAt = async (itemId, scheduledAt = null) => {
		let requestObj = {
			supplier_product_id: itemId,
			scheduled_at: scheduledAt,
		};

		if (scheduledAt) {
			let date = scheduledAt.getDate() < 10 ? `0${scheduledAt.getDate()}` : `${scheduledAt.getDate()}`;
			let month = scheduledAt.getMonth() < 10 ? `0${scheduledAt.getMonth() + 1}` : `${scheduledAt.getMonth() + 1}`;
			let year = scheduledAt.getFullYear();
			requestObj.scheduled_at = `${year}-${month}-${date}`;
		}

		let response;
		response = await this.props.updateInventory(itemId, requestObj);

		if (response) {
			this.handleDateSelectClose();
			this.props.updateSuccessMessage(true, `Item update request added successfully. Item Id: ${requestObj.supplier_product_id}`);
			await this.fetchInventoryItems();
		}
	};

	render() {
		let { inventoryCount, inventoryItems, bucketOrder, bucketState, filteredBuckets, searchText, bulkActionsPopoverAnchorEl, 
			stockStatusPopoverAnchorEl, downloadDataPopoverAnchorEl, optionsPopoverAnchorEl, optionsPopoverItem, addBucketPopoverAnchorEl, 
			bucketPopoverAnchorEl, bucketSearchText, priceSetRef, priceColumnRef, pageSize, pageNumber, renameBucketDialogOpen, 
			cloneBucketDialogOpen, deleteBucketDialogOpen, deleteItemDialogOpen, addSingleItemOpen, addBulkItemsOpen, updateBulkItemsAndStatusOpen, 
			updateBulkBucketPricesOpen, updateItemProductId, deleteItemDialogItem, downloadInventoryItemsDialogOpen, downloadSupplierProductIdsDialogOpen, 
			downloadPricesDialogOpen, filterItemStatusPopoverAnchorEl, filterItemStatusPopoverItem, filterStockStatusPopoverAnchorEl, 
			filterStockStatusPopoverItem, filterIndexStatusPopoverAnchorEl, filterIndexStatusPopoverItem, datePickerOpen } = this.state;
		let { showUploadInventoryFile, disableBucketCreate, disableBucketDelete, disableSingleInventoryCreate, disableSingleInventoryUpdate, 
			disableSingleInventoryDelete, disableSingleStatusUpdate, disableSinglePriceUpdate, disableBulkUploadInventoryCreate, 
			disableBulkUploadInventoryUpdate, disableBulkUploadInventoryDelete, disableBulkUploadPrice, disableBulkDownloadInventory, 
			disableBulkDownloadPrice, supplierMap, supplier, indexStatusOptions } = this.props;

		let filterItemStatusLabel = (ItemStatusOptions.find((option) => option.value === filterItemStatusPopoverItem) || {}).name || '';
		let filterStockStatusLabel = (StockStatusOptions.find((option) => option.value === filterStockStatusPopoverItem) || {}).name || '';
		let filterIndexStatusLabel = (indexStatusOptions.find((option) => option.value === filterIndexStatusPopoverItem) || {}).name || '';
		let isLivePriceSupplier = (supplierMap[supplier] || {}).is_price_fetched || false;

		return (
			<RootContainer>
				<Helmet>
					<title>Seller Portal | Inventory</title>
				</Helmet>

				<CloneBucketDialogBox
					key={DialogIds.CLONE_BUCKET}
					open={cloneBucketDialogOpen}
					onTrue={(value) => {
						this.handleDialogOnTrue(DialogIds.CLONE_BUCKET, value);
					}}
					onFalse={() => {
						this.handleDialogOnFalse(DialogIds.CLONE_BUCKET);
					}}
				/>

				<RenameBucketDialogBox
					key={DialogIds.RENAME_BUCKET}
					open={renameBucketDialogOpen}
					bucket={optionsPopoverItem}
					onTrue={() => {
						this.handleDialogOnTrue(DialogIds.RENAME_BUCKET);
					}}
					onFalse={() => {
						this.handleDialogOnFalse(DialogIds.RENAME_BUCKET);
					}}
				/>

				<DeleteBucketDialogBox
					key={DialogIds.DELETE_BUCKET}
					open={deleteBucketDialogOpen}
					bucket={optionsPopoverItem}
					onTrue={() => {
						this.handleDialogOnTrue(DialogIds.DELETE_BUCKET);
					}}
					onFalse={() => {
						this.handleDialogOnFalse(DialogIds.DELETE_BUCKET);
					}}
				/>

				<DeleteItemDialogBox
					key={DialogIds.DELETE_ITEM}
					open={deleteItemDialogOpen}
					item={deleteItemDialogItem}
					onTrue={() => {
						this.handleDialogOnTrue(DialogIds.DELETE_ITEM);
					}}
					onFalse={() => {
						this.handleDialogOnFalse(DialogIds.DELETE_ITEM);
					}}
				/>

				<DownloadInventoryItems
					key={DialogIds.DOWNLOAD_INVENTORY_ITEMS}
					open={downloadInventoryItemsDialogOpen}
					onTrue={() => {
						this.handleDialogOnTrue(DialogIds.DOWNLOAD_INVENTORY_ITEMS);
					}}
					onFalse={() => {
						this.handleDialogOnFalse(DialogIds.DOWNLOAD_INVENTORY_ITEMS);
					}}
				/>

				<DownloadSupplierProductIds
					key={DialogIds.DOWNLOAD_SUPPLIER_PRODUCT_IDS}
					open={downloadSupplierProductIdsDialogOpen}
					onTrue={() => {
						this.handleDialogOnTrue(DialogIds.DOWNLOAD_SUPPLIER_PRODUCT_IDS);
					}}
					onFalse={() => {
						this.handleDialogOnFalse(DialogIds.DOWNLOAD_SUPPLIER_PRODUCT_IDS);
					}}
				/>

				<DownloadPrices
					key={DialogIds.DOWNLOAD_PRICES}
					open={downloadPricesDialogOpen}
					onTrue={() => {
						this.handleDialogOnTrue(DialogIds.DOWNLOAD_PRICES);
					}}
					onFalse={() => {
						this.handleDialogOnFalse(DialogIds.DOWNLOAD_PRICES);
					}}
				/>

				<Popover
					id={PopoverIds.FILTER_BY_ITEM_STATUS}
					open={Boolean(filterItemStatusPopoverAnchorEl)}
					anchorEl={filterItemStatusPopoverAnchorEl}
					onClose={() => this.handlePopoverClose(PopoverIds.FILTER_BY_ITEM_STATUS)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'center',
					}}
				>
					<PopoverTitle>Select Item Status</PopoverTitle>

					<PopoverBody style={{ minWidth: '120px' }}>
						{ItemStatusOptions.map((item, index) => (
							<PopoverItem
								key={index}
								disabled={item.disabled || item.value === filterItemStatusPopoverItem}
								onClick={(e) => this.handlePopoverSelect(PopoverIds.FILTER_BY_ITEM_STATUS, item)}
							>
								{item.name}
							</PopoverItem>
						))}
					</PopoverBody>
				</Popover>

				<Popover
					id={PopoverIds.FILTER_BY_STOCK_STATUS}
					open={Boolean(filterStockStatusPopoverAnchorEl)}
					anchorEl={filterStockStatusPopoverAnchorEl}
					onClose={() => this.handlePopoverClose(PopoverIds.FILTER_BY_STOCK_STATUS)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'center',
					}}
				>
					<PopoverTitle>Select Stock Status</PopoverTitle>

					<PopoverBody style={{ minWidth: '120px' }}>
						{StockStatusOptions.map((item, index) => (
							<PopoverItem
								key={index}
								disabled={item.disabled || item.value === filterStockStatusPopoverItem}
								onClick={(e) => this.handlePopoverSelect(PopoverIds.FILTER_BY_STOCK_STATUS, item)}
							>
								{item.name}
							</PopoverItem>
						))}
					</PopoverBody>
				</Popover>

				<Popover
					id={PopoverIds.FILTER_BY_INDEX_STATUS}
					open={Boolean(filterIndexStatusPopoverAnchorEl)}
					anchorEl={filterIndexStatusPopoverAnchorEl}
					onClose={() => this.handlePopoverClose(PopoverIds.FILTER_BY_INDEX_STATUS)}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'center',
					}}
				>
					<PopoverTitle>Select Index Status</PopoverTitle>

					<PopoverBody style={{ minWidth: '120px' }}>
						{indexStatusOptions.map((item, index) => (
							<PopoverItem
								key={index}
								disabled={item.disabled || item.value === filterIndexStatusPopoverItem}
								onClick={(e) => this.handlePopoverSelect(PopoverIds.FILTER_BY_INDEX_STATUS, item)}
							>
								{item.name}
							</PopoverItem>
						))}
					</PopoverBody>
				</Popover>

				<Popover
					id={PopoverIds.BULK_ACTIONS}
					open={Boolean(bulkActionsPopoverAnchorEl)}
					anchorEl={bulkActionsPopoverAnchorEl}
					onClose={() => this.handlePopoverClose(PopoverIds.BULK_ACTIONS)}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
					transformOrigin={{ vertical: 'top', horizontal: 'right' }}
				>
					{!disableBulkUploadInventoryCreate ? (
						<PopoverItem
							disabled={showUploadInventoryFile}
							onClick={(e) => {
								this.handlePopoverSelect(PopoverIds.BULK_ACTIONS, 'ADD_BULK_ITEMS');
							}}
						>
							Add Items In Bulk
						</PopoverItem>
					) : null}

					{!disableBulkUploadInventoryUpdate ? (
						<PopoverItem
							disabled={showUploadInventoryFile || inventoryCount === 0}
							onClick={(e) => {
								this.handlePopoverSelect(PopoverIds.BULK_ACTIONS, 'UPDATE_BULK_ITEMS_AND_STATUS');
							}}
						>
							{!isLivePriceSupplier ? 'Update Items And Status In Bulk' : 'Update Items In Bulk'}
						</PopoverItem>
					) : null}

					{!isLivePriceSupplier && !disableBulkUploadPrice ? (
						<PopoverItem
							disabled={showUploadInventoryFile || inventoryCount === 0}
							onClick={(e) => {
								this.handlePopoverSelect(PopoverIds.BULK_ACTIONS, 'UPDATE_BULK_BUCKET_PRICES');
							}}
						>
							Update Bucket Prices In Bulk
						</PopoverItem>
					) : null}

					{!disableBulkUploadInventoryDelete && false ? (
						<PopoverItem
							disabled={showUploadInventoryFile || inventoryCount === 0}
							onClick={(e) => {
								this.handlePopoverSelect(PopoverIds.BULK_ACTIONS, 'DELETE_BULK_ITEMS');
							}}
						>
							Delete Items In Bulk
						</PopoverItem>
					) : null}
				</Popover>

				<Popover
					id={PopoverIds.STOCK_STATUS}
					open={Boolean(stockStatusPopoverAnchorEl)}
					anchorEl={stockStatusPopoverAnchorEl}
					onClose={() => this.handlePopoverClose(PopoverIds.STOCK_STATUS)}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
					transformOrigin={{ vertical: 'top', horizontal: 'left' }}
				>
					{StockStatusOptions.map((option) => {
						if (option.value) {
							return (
								<PopoverItem
									key={option.value}
									onClick={(e) => this.handlePopoverSelect(PopoverIds.STOCK_STATUS, option.value)}
								>
									{option.name}
								</PopoverItem>
							);
						}
						return null;
					})}
				</Popover>

				<Popover
					id={PopoverIds.BUCKET}
					open={Boolean(bucketPopoverAnchorEl)}
					anchorEl={bucketPopoverAnchorEl}
					onClose={() => this.handlePopoverClose(PopoverIds.BUCKET)}
					anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				>
					<PopoverTitle>Select Bucket</PopoverTitle>

					<PopoverItem>
						<Search
							searchText={bucketSearchText}
							placeholder={'Search Bucket'}
							searchOnChange={true}
							onSearchHandler={(value) => this.handleBucketSearchText(value)}
						/>
					</PopoverItem>

					<PopoverBody>
						{bucketSearchText ? (
							filteredBuckets.length > 0 ? (
								filteredBuckets.map((bucket, index) => (
									<PopoverItem
										key={bucket}
										disabled={bucketState[bucket] && bucketState[bucket].display}
										onClick={(e) => this.handlePopoverSelect(PopoverIds.BUCKET, bucket)}
									>
										{bucketState[bucket].alias}
									</PopoverItem>
								))
							) : (
								<NotFound line1="Couldn't find any items" />
							)
						) : Object.keys(bucketState).length > 0 ? (
							Object.keys(bucketState).map((bucket, index) => (
								<PopoverItem
									key={bucket}
									disabled={bucketState[bucket] && bucketState[bucket].display}
									onClick={(e) => this.handlePopoverSelect(PopoverIds.BUCKET, bucket)}
								>
									{bucketState[bucket].alias}
								</PopoverItem>
							))
						) : (
							<NotFound line1="Couldn't find any items" />
						)}
					</PopoverBody>
				</Popover>

				<Popover
					id={PopoverIds.ADD_BUCKET}
					open={Boolean(addBucketPopoverAnchorEl)}
					anchorEl={addBucketPopoverAnchorEl}
					onClose={() => this.handlePopoverClose(PopoverIds.ADD_BUCKET)}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<PopoverTitle>Add New Bucket</PopoverTitle>

					<PopoverItem>
						<Search
							searchText={bucketSearchText}
							placeholder={'Search Bucket'}
							searchOnChange={true}
							onSearchHandler={(value) => this.handleBucketSearchText(value)}
						/>
					</PopoverItem>

					<PopoverBody>
						{bucketSearchText ? (
							filteredBuckets.length > 0 ? (
								filteredBuckets.map((bucket, index) => (
									<PopoverItem key={bucket}>
										{bucketState[bucket].alias}
										<span
											style={{ display: 'flex', marginLeft: 'auto', color: Theme.blue }}
											onClick={(e) => {
												this.handlePopoverSelect(PopoverIds.ADD_BUCKET, bucket);
											}}
										>
											<CloneIcon />
											Clone
										</span>
									</PopoverItem>
								))
							) : (
								<NotFound line1="Couldn't find any items" />
							)
						) : (
							<>
								<PopoverItem>
									Base Price
									<span
										style={{ display: 'flex', marginLeft: 'auto', color: Theme.blue }}
										onClick={(e) => {
											this.handlePopoverSelect(PopoverIds.ADD_BUCKET, 'price');
										}}
									>
										<CloneIcon />
										Clone
									</span>
								</PopoverItem>
								{Object.keys(bucketState).length
									? Object.keys(bucketState).map((bucket, index) => (
											<PopoverItem key={bucket}>
												{bucketState[bucket].alias}
												<span
													style={{ display: 'flex', marginLeft: 'auto', color: Theme.blue }}
													onClick={(e) => {
														this.handlePopoverSelect(PopoverIds.ADD_BUCKET, bucket);
													}}
												>
													<CloneIcon />
													Clone
												</span>
											</PopoverItem>
									  ))
									: null}
							</>
						)}
					</PopoverBody>
				</Popover>

				<Popover
					id={PopoverIds.OPTIONS}
					open={Boolean(optionsPopoverAnchorEl)}
					anchorEl={optionsPopoverAnchorEl}
					onClose={() => this.handlePopoverClose(PopoverIds.OPTIONS)}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				>
					<PopoverItem onClick={(e) => this.handlePopoverSelect(PopoverIds.OPTIONS, 'RENAME')}>
						<EditIcon /> Rename Bucket
					</PopoverItem>

					{!disableBucketCreate ? (
						<PopoverItem onClick={(e) => this.handlePopoverSelect(PopoverIds.OPTIONS, 'CLONE')}>
							<CloneIcon /> Clone Bucket
						</PopoverItem>
					) : null}

					<PopoverItem onClick={(e) => this.handlePopoverClick(PopoverIds.BUCKET, e)}>
						<ChangeIcon /> Change Bucket
					</PopoverItem>

					{!disableBucketDelete ? (
						<PopoverItem
							onClick={(e) => this.handlePopoverSelect(PopoverIds.OPTIONS, 'DELETE')}
							style={{ color: Theme.red }}
							disabled={
								optionsPopoverItem &&
								bucketState[optionsPopoverItem] &&
								(bucketState[optionsPopoverItem].pending_map_updates > 0 ||
									bucketState[optionsPopoverItem].mapped_dso.length > 0 ||
									bucketState[optionsPopoverItem].mapped_user.length > 0)
							}
						>
							<TrashIcon /> Delete Bucket
						</PopoverItem>
					) : null}
				</Popover>

				<Popover
					id={PopoverIds.DOWNLOAD_DATA}
					open={Boolean(downloadDataPopoverAnchorEl)}
					anchorEl={downloadDataPopoverAnchorEl}
					onClose={() => this.handlePopoverClose(PopoverIds.DOWNLOAD_DATA)}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
					transformOrigin={{ vertical: 'top', horizontal: 'right' }}
				>
					{!disableBulkDownloadInventory ? (
						<>
							<PopoverItem
								onClick={(e) => {
									this.handlePopoverSelect(PopoverIds.DOWNLOAD_DATA, 'DOWNLOAD_INVENTORY_ITEMS');
								}}
							>
								Download Inventory Items
							</PopoverItem>

							<PopoverItem
								onClick={(e) => {
									this.handlePopoverSelect(PopoverIds.DOWNLOAD_DATA, 'DOWNLOAD_SUPPLIER_PRODUCT_IDS');
								}}
							>
								Download Item Ids
							</PopoverItem>
						</>
					) : null}

					{!isLivePriceSupplier && !disableBulkDownloadPrice ? (
						<PopoverItem
							onClick={(e) => {
								this.handlePopoverSelect(PopoverIds.DOWNLOAD_DATA, 'DOWNLOAD_PRICES');
							}}
						>
							Download Prices
						</PopoverItem>
					) : null}
				</Popover>

				{addSingleItemOpen ? (
					<AddSingleItem
						open={addSingleItemOpen}
						toggle={this.toggleAddSingleItem}
						updateItem={updateItemProductId ? true : false}
						productId={updateItemProductId}
						onSuccess={() => {
							this.fetchInventoryItems();
							this.fetchAutocompleteLists();
						}}
					/>
				) : null}

				{addBulkItemsOpen ? (
					<AddBulkItems
						open={addBulkItemsOpen}
						updateItems={updateBulkItemsAndStatusOpen ? true : false}
						toggle={updateBulkItemsAndStatusOpen ? this.toggleUpdateBulkItemsAndStatusOpen : this.toggleAddBulkItems}
						onSuccess={() => {
							this.fetchInventoryItems();
							this.fetchAutocompleteLists();
						}}
					/>
				) : null}

				{updateBulkBucketPricesOpen ? (
					<UpdateBulkBucketPrices
						open={updateBulkBucketPricesOpen}
						bucketState={bucketState}
						toggle={this.toggleUpdateBulkBucketPrices}
						onSuccess={() => {
							this.fetchInventoryItems();
							this.fetchAutocompleteLists();
						}}
					/>
				) : null}

				<TitleSection>
					<TitleRow responsive='1200px'>
						<FlexColumn style={{ flex: 'auto' }}>
							<FlexRow style={{ gap: '2rem', justifyContent: 'space-between' }}>
								<Title>Inventory</Title>

								<Search
									searchText={searchText}
									placeholder={'Search with exact Item ID and press enter'}
									enableDelayOnChange={true}
									searchOnChange={true}
									onSearchHandler={(value) => {
										this.handleSearchText(value);
									}}
								/>
							</FlexRow>
						</FlexColumn>

						<FlexColumn style={{ alignSelf: 'center' }}>
							<ButtonGroup alignRight>
								<FilterButton
									primary
									outline
									onClick={(e) => this.handlePopoverClick(PopoverIds.FILTER_BY_ITEM_STATUS, e)}
								>
									<ItemStatusIcon />
									{filterItemStatusLabel}
									<ArrowDownIcon />
								</FilterButton>

								{!isLivePriceSupplier ? (
									<FilterButton
										primary
										outline
										onClick={(e) => this.handlePopoverClick(PopoverIds.FILTER_BY_STOCK_STATUS, e)}
									>
										<StockStatusIcon />
										{filterStockStatusLabel}
										<ArrowDownIcon />
									</FilterButton>
								) : null}

								{/* <FilterButton
									primary
									outline
									onClick={(e) => this.handlePopoverClick(PopoverIds.FILTER_BY_INDEX_STATUS, e)}
								>
									<IndexStatusIcon />
									{filterIndexStatusLabel}
									<ArrowDownIcon />
								</FilterButton> */}

								{!disableSingleInventoryCreate ? (
									<Button
										primary
										onClick={(e) => this.toggleAddSingleItem()}
									>
										<AddIcon />
										Add New Item
									</Button>
								) : null}

								{!disableBulkUploadInventoryCreate || !disableBulkUploadInventoryUpdate || !disableBulkUploadPrice ? (
									showUploadInventoryFile ? (
										<Button
											secondary
											onClick={(e) => this.showUploadInventoryFileDialog()}
										>
											<ProcessingIcon />
											Show Upload Progress
										</Button>
									) : (
										<Button
											primary
											onClick={(e) => this.handlePopoverClick(PopoverIds.BULK_ACTIONS, e)}
										>
											<AddIcon />
											Bulk Actions
										</Button>
									)
								) : null}

								{!disableBulkDownloadInventory || !disableBulkDownloadPrice ? (
									<Button
										secondary
										disabled={inventoryCount === 0}
										onClick={(e) => this.handlePopoverClick(PopoverIds.DOWNLOAD_DATA, e)}
									>
										<DownloadIcon />
										Download Items
									</Button>
								) : null}

								<SquareButton
									secondary
									onClick={(e) => {
										this.refreshInventoryData();
									}}
								>
									<RefreshInventoryIcon />
								</SquareButton>
							</ButtonGroup>
						</FlexColumn>
					</TitleRow>
				</TitleSection>

				<SubtitleSection>
					<SubtitleRow responsive='1200px'>
						<FlexColumn>
							<Subtitle>{`${inventoryCount || 0} ${(inventoryCount || 0) === 1 ? 'Item' : 'Items'}`}</Subtitle>
						</FlexColumn>

						<FlexColumn style={{ alignItems: 'flex-end', marginLeft: 'auto', justifyContent:'right' }}>
							<FlexRow style={{ gap: '0.5rem' }}>
								<Note>All updates which require approval will reflect on Dentira website next business day if approved.</Note>
							</FlexRow>
						</FlexColumn>
					</SubtitleRow>
				</SubtitleSection>

				<TableContainer>
					<Table>
						<TableHeader>
							<TableHeaderRow>
								<TableHeaderColumn 
									style={{ width: !isLivePriceSupplier ? '30rem' : '100%', minWidth: '30rem' }}
								>
									Item Name
								</TableHeaderColumn>

								{!isLivePriceSupplier ? (
									<TableHeaderColumn
										alignLeft
										style={{ width: '10rem', minWidth: '10rem' }}
									>
										Status
									</TableHeaderColumn>
								) : null}

								{!isLivePriceSupplier ? (
									<TableHeaderColumn
										alignCenter
										style={{ flex: 1, minWidth: '20rem' }}
										ref={priceSetRef}
									>
										<PriceGroup>
											<PriceHeaderColumn>Base Price</PriceHeaderColumn>

											{Object.keys(bucketState).length > 0 && bucketOrder.map((bucket, index) => {
												return bucketState[bucket] && bucketState[bucket].display 
												?	<PriceHeaderColumn
														key={bucket}
														onClick={(e) => {
															this.setState({ optionsPopoverItem: bucket, bucketPopoverItem: bucket });
															this.handlePopoverClick(PopoverIds.OPTIONS, e);
														}}
													>
														{bucketState[bucket].alias}
														<ArrowDownIcon />
													</PriceHeaderColumn>
												: 	null;
											})}
										</PriceGroup>
									</TableHeaderColumn>
								) : null}

								{!isLivePriceSupplier && !disableBucketCreate ? (
									<CloneHeaderColumn
										alignCenter
										style={{ width: '4rem', minWidth: '4rem' }}
									>
										<ButtonGroup>
											<CircularButton
												primary
												onClick={(e) => {
													this.handlePopoverClick(PopoverIds.ADD_BUCKET, e);
												}}
											>
												<PlusIcon />
											</CircularButton>
										</ButtonGroup>
									</CloneHeaderColumn>
								) : null}

								{!(disableSingleInventoryUpdate && disableSingleInventoryDelete) ? (
									<TableHeaderColumn
										alignRight
										style={{ width: '5rem', minWidth: '5rem' }}
									>
										Actions
									</TableHeaderColumn>
								) : null}
							</TableHeaderRow>
						</TableHeader>

						<TableBody>
							{inventoryItems && inventoryItems.length ? (
								inventoryItems.map((item, index) => (
									<TableRow key={index}>
										<TableColumn>
											<FlexRow>
												<FlexColumn style={{ width: '3rem', height: '3rem', alignItems:"center", backgroundColor: Theme.lightWhite, borderRadius: '4px' }}>
													<ProductImage
														src={item.image_url ? item.image_url : NotFoundIcon}
														alt='Not Found'
													/>
												</FlexColumn>

												<FlexColumn style={{ paddingLeft: '10px', alignSelf: 'center', lineHeight: '18px' }}>
													<FlexRow>{item.name ? item.name : ''}</FlexRow>

													<FlexRow style={{ fontSize: '12px', fontWeight: '400' }}>{item.supplier_product_id} | {item.manufacturer_id}</FlexRow>

													<FlexRow style={{ fontSize: '11px', fontWeight: '400' }}>
														{item.metadata && item.metadata.action 
														?	<span style={{ color: Theme.red }}>
																{item.metadata.action === 'create' 
																?	"Item create request waiting for approval"
																:	item.metadata.action === 'update'
																?	"Item update request waiting for approval"
																:	item.metadata.action === 'delete'
																?	"Item delete request waiting for approval"
																:	"Waiting for approval"
																}
															</span>
														:	item.scheduled_at 
														?	<div style={{ display: 'flex', gap: '0.5rem' }}>
																<span style={{ color: Theme.orange }}>{`Scheduled at ${item.scheduled_at}`}</span>
																{' • '}
																<LocalizationProvider>
																	<DatePicker
																		value={null}
																		open={datePickerOpen}
																		disableCloseOnSelect={false}
																		disablePast
																		onChange={(date) => this.handleUpdateScheduledAt(item.supplier_product_id, date)}
																		onClose={() => this.handleDateSelectClose()}
																		renderInput={(props) => (
																			<span
																				style={{ color: Theme.blue }}
																				onClick={(e) => {
																					this.handleDateSelectOpen();
																				}}
																			>
																				{`Update Schedule`}
																			</span>
																		)}
																		PopperProps={{ style: { position: 'relative' } }}
																	/>
																</LocalizationProvider>
																{' • '}
																<span
																	style={{ color: Theme.red }}
																	onClick={() => {
																		this.handleUpdateScheduledAt(item.supplier_product_id, null);
																	}}
																>
																	{`Delete Schedule`}
																</span>
															</div>
														: (item.updated_at && new Date(item.updated_at) > DATE_24_HOURS_BACK) || 
															(item.created_at && new Date(item.created_at) > DATE_24_HOURS_BACK)
														?	<span style={{ color: Theme.blue }}>
																Changes waiting to go live
															</span>
														: <span style={{ color: Theme.green }}>
																Active
															</span>
														}
													</FlexRow>
												</FlexColumn>
											</FlexRow>
										</TableColumn>

										{!isLivePriceSupplier ? (
											<TableColumn alignLeft>
												{!(item.metadata && item.metadata.action && item.metadata.action === 'create') ? (
													<StockStatusColumn
														disabled={disableSingleStatusUpdate}
														status={STOCK_STATUS[item.availability_status] ? STOCK_STATUS[item.availability_status] : null}
														onClick={(e) => {
															if (!disableSingleStatusUpdate) {
																this.setState({ stockStatusPopoverItem: item.supplier_product_id });
																this.handlePopoverClick(PopoverIds.STOCK_STATUS, e);
															}
														}}
													>
														{STOCK_STATUS[item.availability_status] ? STOCK_STATUS[item.availability_status] : null}
														{!disableSingleStatusUpdate ? <StockStatusDropdownIcon /> : null}
													</StockStatusColumn>
												) : null}
											</TableColumn>
										) : null}

										{!isLivePriceSupplier ? (
											<TableColumn alignCenter>
												<PriceGroup>
													<PriceColumn>
														<Price
															ref={priceColumnRef}
															locked={item[`price_new`] !== undefined ? true : false}
															placeholder={'Not Set'}
															disabled={
																disableSinglePriceUpdate || (item.metadata !== undefined && item.metadata.action && ['create', 'delete'].includes(item.metadata.action))
															}
															onBlurHandler={(value) => {
																this.handleUpdatePrice(item.supplier_product_id, 'price', value);
															}}
															defaultValue={managePricingLogic(item[`price`], item[`price_new`])}
															showReset={false}
															onResetHandler={() => {
																this.handleUpdatePrice(item.supplier_product_id, 'price', null);
															}}
														/>
													</PriceColumn>

													{Object.keys(bucketState).length > 0 &&
														bucketOrder.map((bucket, index) => {
															return bucketState[bucket] && bucketState[bucket].display ? (
																<PriceColumn>
																	<Price
																		locked={item[`${bucket}_new`] !== undefined ? true : false}
																		placeholder={'Not Set'}
																		disabled={
																			disableSinglePriceUpdate ||
																			(item.metadata !== undefined && item.metadata.action && ['create', 'delete'].includes(item.metadata.action)) ||
																			bucketState[bucket].pending_map_updates > 0
																		}
																		onBlurHandler={(value) => {
																			this.handleUpdatePrice(item.supplier_product_id, bucket, value);
																		}}
																		defaultValue={managePricingLogic(item[`${bucket}`], item[`${bucket}_new`])}
																		showReset={true}
																		onResetHandler={() => {
																			this.handleUpdatePrice(item.supplier_product_id, bucket, null);
																		}}
																	/>
																</PriceColumn>
															) : null;
														})}
												</PriceGroup>
											</TableColumn>
										) : null}

										{!isLivePriceSupplier && !disableBucketCreate ? <TableColumn alignCenter>{/* To maintain the table dimensions */}</TableColumn> : null}

										{!(disableSingleInventoryUpdate && disableSingleInventoryDelete) ? (
											<TableColumn alignRight>
												<FlexRow>
													<ButtonGroup alignRight>
														{!disableSingleInventoryUpdate ? (
															<SquareButton
																secondary
																outline
																disabled={item.metadata && item.metadata.action ? true : false}
																onClick={(e) => {
																	this.setState({ updateItemProductId: item.supplier_product_id }, () => {
																		this.toggleAddSingleItem();
																	});
																}}
															>
																<EditIcon />
															</SquareButton>
														) : null}

														{!disableSingleInventoryDelete ? (
															<SquareButton
																error
																outline
																disabled={
																	(item.metadata && item.metadata.action) ||
																	['price', ...Object.keys(bucketState)].some((bucket, index) => (Object.keys(item).includes(`${bucket}_new`) ? true : false))
																		? true
																		: false
																}
																onClick={(e) => {
																	this.setState({ deleteItemDialogItem: item.supplier_product_id, deleteItemDialogOpen: true });
																}}
															>
																<TrashIcon />
															</SquareButton>
														) : null}
													</ButtonGroup>
												</FlexRow>
											</TableColumn>
										) : null}
									</TableRow>
								))
							) : (
								<TableRow key='not-found'>
									<TableColumn colSpan={'100%'}>
										<NotFound lines={["Couldn't find any items"]} />
									</TableColumn>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>

				<TablePagination
					component='div'
					count={inventoryCount ? inventoryCount : 0}
					page={pageNumber}
					onPageChange={(e, page) => {
						this.setState({ pageNumber: parseInt(page, 10) });
					}}
					rowsPerPage={pageSize}
					onRowsPerPageChange={(e) => {
						this.setState({ pageSize: parseInt(e.target.value, 10), pageNumber: 0 });
					}}
				/>
			</RootContainer>
		);
	}
}

const mapStateToProps = (state) => {
	let supplierSellerPortalConfig = state.supplier.sellerPortalConfig || {};
	let userSellerPortalConfig = state.session.sellerPortalConfig || {};

	let disableBucketCreate = supplierSellerPortalConfig.disable_bucket_create || userSellerPortalConfig.disable_bucket_create || false;
	let disableBucketDelete = supplierSellerPortalConfig.disable_bucket_delete || userSellerPortalConfig.disable_bucket_delete || false;
	let disableSingleInventoryCreate = supplierSellerPortalConfig.disable_single_inventory_create || userSellerPortalConfig.disable_single_inventory_create || false;
	let disableSingleInventoryUpdate = supplierSellerPortalConfig.disable_single_inventory_update || userSellerPortalConfig.disable_single_inventory_update || false;
	let disableSingleInventoryDelete = supplierSellerPortalConfig.disable_single_inventory_delete || userSellerPortalConfig.disable_single_inventory_delete || false;
	let disableSingleStatusUpdate = supplierSellerPortalConfig.disable_single_status_update || userSellerPortalConfig.disable_single_status_update || false;
	let disableSinglePriceUpdate = supplierSellerPortalConfig.disable_single_price_update || userSellerPortalConfig.disable_single_price_update || false;
	let disableBulkUploadInventoryCreate = supplierSellerPortalConfig.disable_bulk_upload_inventory_create || userSellerPortalConfig.disable_bulk_upload_inventory_create || false;
	let disableBulkUploadInventoryUpdate = supplierSellerPortalConfig.disable_bulk_upload_inventory_update || userSellerPortalConfig.disable_bulk_upload_inventory_update || false;
	let disableBulkUploadInventoryDelete = supplierSellerPortalConfig.disable_bulk_upload_inventory_delete || userSellerPortalConfig.disable_bulk_upload_inventory_delete || false;
	let disableBulkUploadPrice = supplierSellerPortalConfig.disable_bulk_upload_price || userSellerPortalConfig.disable_bulk_upload_price || false;
	let disableBulkDownloadInventory = supplierSellerPortalConfig.disable_bulk_download_inventory || userSellerPortalConfig.disable_bulk_download_inventory || false;
	let disableBulkDownloadPrice = supplierSellerPortalConfig.disable_bulk_download_price || userSellerPortalConfig.disable_bulk_download_price || false;

	return {
		tile: state.tiles.tile,
		disableBucketCreate,
		disableBucketDelete,
		disableSingleInventoryCreate,
		disableSingleInventoryUpdate,
		disableSingleInventoryDelete,
		disableSingleStatusUpdate,
		disableSinglePriceUpdate,
		disableBulkUploadInventoryCreate,
		disableBulkUploadInventoryUpdate,
		disableBulkUploadInventoryDelete,
		disableBulkUploadPrice,
		disableBulkDownloadInventory,
		disableBulkDownloadPrice,
		inventory: state.inventory.inventory,
		bucketItems: state.inventory.bucketItems,
		bucketOrder: state.inventory.bucketOrder,
		supplier: state.supplier.supplier,
		supplierMap: state.supplier.suppliers_map,
		showUploadInventoryFile: (state.inventory.showUploadInventoryFile && state.inventory.uploadInventoryFileAction !== BULK_FILE_UPLOAD_STAGES.UPLOAD) || false,
		uploadInventoryFileAction: state.inventory.uploadInventoryFileAction || '',
		uploadInventoryFileBatch: state.inventory.uploadInventoryFileBatch || '',
		uploadInventoryFileType: state.inventory.uploadInventoryFileType || '',
		indexStatusOptions: [{ name: 'All', value: '', disabled: false }, ...(state.inventory.mappedDSOOptions || [])],
	};
};

const mapDispatch = {
	changeTile,
	updateError,
	updateErrorMessage,
	updateMessage,
	updateSuccessMessage,
	fetchInventoryItems,
	updateStatus,
	fetchBucketList,
	updateBucketPrice,
	updateBucketOrder,
	cloneBucket,
	updateInventory,
	deleteInventory,
	setUploadInventoryFileAction,
	setUploadInventoryFileBatch,
	fetchUploadInventoryFileBatch,
	fetchAutocompleteManufacturer,
	fetchAutocompleteMappedSupplier,
	fetchAutocompletePackaging,
	fetchAutocompleteMappedDSO,
	fetchAutocompleteCategory,
};

export default withRouter(connect(mapStateToProps, mapDispatch)(InventoryV2));
